import { pxToRem } from '../../helpers'
import { ThemeTokens } from '../../theming'
import { StyleFn } from '..'

const SpinnerLabel = (theme: ThemeTokens) => {
  const { color, font, size } = theme
  const textColor = color.getModalValues(color.text.primary)
  return {
    position: 'absolute',
    top: `calc(100% + ${size.spacing[8]})`,
    left: `calc(-${size.spacing[64]})`,
    right: `calc(-${size.spacing[64]})`,
    fontSize: font.size.xsmall,
    textAlign: 'center',
    color: textColor,
  }
}

export const Spinner: StyleFn = (theme) => {
  const { color, font, size } = theme
  const textColor = color.getModalValues(color.text.primary)
  const circleColor = color.type === 'light' ? color.brand.lighter : color.palette.white
  return {
    '@keyframes circle': {
      to: { transform: 'rotate(360deg);' },
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: size.spacing[24],
      width: size.spacing[24],
      height: size.spacing[24],
      overflow: 'visible',
      fontSize: font.size.small,
      margin: 3,
      color: textColor,
      position: 'relative',
      '&:before': {
        position: 'absolute',
        content: '""',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        border: `3px solid ${circleColor}`,
        borderRightColor: 'transparent !important',
        borderRadius: '50%',
        animation: '$circle .75s linear infinite',
      },
    },
    label: SpinnerLabel(theme),
    _medium: {
      minWidth: pxToRem(64 - 6),
      width: pxToRem(64 - 6),
      height: pxToRem(64 - 6),
      borderWidth: size.spacing[4],
    },
  }
}

export const Progresscircle: StyleFn = (theme) => {
  const { color, font, size } = theme
  const circleColor = color.type === 'light' ? color.brand.lighter : color.palette.white
  const backgroundColor = color.type === 'light' ? color.palette.white : color.brand.darker
  const trackColor = color.type === 'light' ? color.palette.coolgrey[10] : color.palette.coolgrey[70]
  const textColor = color.getModalValues(color.text.primary)

  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: textColor,
      fontSize: font.size.small,
      minWidth: size.spacing[24],
      width: size.spacing[24],
      height: size.spacing[24],
      margin: 3,
      borderRadius: '50%',
      position: 'relative',
      background: `conic-gradient(${circleColor} calc(var(--percentage)*1%), ${trackColor} 0)`,
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 3,
        left: 3,
        right: 3,
        bottom: 3,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
      },
      "& > div[role='status']": {
        position: 'absolute',
      },
    },
    label: SpinnerLabel(theme),
    _medium: {
      minWidth: pxToRem(64 - 6),
      width: pxToRem(64 - 6),
      height: pxToRem(64 - 6),
    },
  }
}

export const Dots = ({ color, size }: any) => {
  const circleColor = color.type === 'light' ? color.brand.lighter : color.palette.white
  return {
    '@keyframes wave': {
      ['0%']: {
        transform: 'translate(0, 0)',
        opacity: 1,
      },
      ['30%']: {
        transform: 'translate(0, -4px)',
        opacity: 0.5,
      },
      ['60%']: {
        transform: 'translate(0, 0)',
        opacity: 1,
      },
      ['100%']: {
        transform: 'translate(0, 0)',
        opacity: 1,
      },
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    item: {
      display: 'inline-block',
      marginRight: size.spacing[8],
      width: size.spacing[8],
      height: size.spacing[8],
      borderRadius: size.spacing[8],
      backgroundColor: circleColor,
      '&:first-child': {
        animation: '$wave 1s 0.2s ease infinite',
      },
      '&:nth-child(even)': {
        animation: '$wave 1s 0.4s ease infinite',
      },
      '&:last-child': {
        marginRight: 0,
        animation: '$wave 1s 0.5s ease infinite',
      },
    },
  }
}
